(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["_header-menu"] && !Shopify.designMode) return;
  try {
    (function () {
  // Ensure logo is visible and non-clickable on mobile & desktop for 2nd-trackable-passport
  (function () {
    if (
      window.location.pathname.indexOf('2nd-trackable-passport') !== -1 ||
      window.location.href.indexOf('2nd-trackable-passport') !== -1 ||
      (document.body && document.body.className.indexOf('2nd-trackable-passport') !== -1)
    ) {
      document.documentElement.classList.remove('hide-header-logo-page');
      document.documentElement.classList.add('disable-logo-link-page');
      var setupFn = function () {
        var items = document.querySelectorAll(
          'header-logo, .header-logo, [class*="header-logo"], .header__heading, .header__heading-link, .header__logo, .site-header__logo'
        );
        for (var k = 0; k < items.length; k++) {
          var item = items[k];
          item.style.setProperty('display', 'inline-flex', 'important');
          item.style.setProperty('visibility', 'visible', 'important');
          item.style.setProperty('opacity', '1', 'important');
          item.style.setProperty('pointer-events', 'none', 'important');
          item.style.setProperty('cursor', 'default', 'important');

          var link = item.tagName === 'A' ? item : item.querySelector('a');
          if (link) {
            link.removeAttribute('href');
            link.setAttribute('tabindex', '-1');
            link.setAttribute('aria-disabled', 'true');
            link.style.setProperty('pointer-events', 'none', 'important');
            link.style.setProperty('cursor', 'default', 'important');
          }
        }
      };
      setupFn();
      if (window.MutationObserver) {
        new MutationObserver(setupFn).observe(document.documentElement, {
          childList: true,
          subtree: true,
        });
      }
    }
  })();

  if (window.customProductMegaMenuInitialized) return;

  window.customProductMegaMenuInitialized = true;

  document.addEventListener(
    'click',
    function (event) {
      const trigger = event.target.closest(
        '[data-mobile-submenu-trigger]'
      );

      if (!trigger) return;

      const menuItem = trigger.closest(
        '.mobile-menu-item--has-submenu'
      );

      if (!menuItem) return;

      event.preventDefault();
      event.stopPropagation();

      const isOpen = !menuItem.classList.contains('is-open');

      menuItem.classList.toggle('is-open', isOpen);

      trigger.setAttribute(
        'aria-expanded',
        isOpen ? 'true' : 'false'
      );
    },
    true
  );

  document.addEventListener(
    'click',
    function (event) {
      const menuRow = event.target.closest(
        '[class*="ai-mobile-menu-link-"]'
      );

      if (!menuRow) return;

      const submenuToggle = menuRow.querySelector(
        '[class*="ai-mobile-menu-submenu-toggle-"]'
      );

      if (!submenuToggle) return;

      if (
        event.target.closest(
          '[class*="ai-mobile-menu-submenu-toggle-"]'
        )
      ) {
        return;
      }

      event.preventDefault();
      event.stopPropagation();

      submenuToggle.click();
    },
    true
  );

  function updateSubmenuPositions() {
    const menuItems = document.querySelectorAll(
      '.menu-list__list-item--has-submenu'
    );

    menuItems.forEach(function (menuItem) {
      const rect = menuItem.getBoundingClientRect();

      menuItem.style.setProperty(
        '--submenu-offset-left',
        rect.left + 'px'
      );
    });
  }

  function initializeMegaMenu() {
    updateSubmenuPositions();
  }

  if (document.readyState === 'loading') {
    document.addEventListener(
      'DOMContentLoaded',
      initializeMegaMenu,
      { once: true }
    );
  } else {
    initializeMegaMenu();
  }

  window.addEventListener(
    'resize',
    updateSubmenuPositions
  );
})();
  } catch(e) { console.error(e); }
})();

})();
